<template>
  <WdsStack direction-column gap-md>
    <WdsProgressBar :progress />

    <template v-if="hasBlockingChecks">
      <WdsAlert v-if="(blockingPending ?? 0) > 0" warning icon>
        {{ $tc(':count required check left | :count required checks left', blockingPending) }}
      </WdsAlert>
      <WdsAlert v-else success icon>{{ $t('All required checks done') }}</WdsAlert>
    </template>
  </WdsStack>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsAlert, WdsProgressBar, WdsStack } from '@worksome/wds-components'
import { $t, $tc } from '@/app-bootstrapping/SetUpInternationalization'

// Leave out the blocking props to show the bar alone.
const props = defineProps<{
  done: number
  total: number
  blockingPending?: number
  hasBlockingChecks?: boolean
}>()

const progress = computed(() =>
  props.total > 0 ? Math.round((props.done / props.total) * 100) : 0,
)
</script>
